module.exports = __webpack_public_path__ + "media/static/icons/icon-thumbs-up-solid-44cf31f1429e4da648eaf475a3decac3.svg";